
export default {
    namespaced: true,

    state: {

        interacciones: [],
        historial: [],
        mensajes: [],
        umbrales: []

    },

    getters: {

        getInteracciones(state){ //take parameter state
            return state.interacciones
        },
        getHistorial(state){
            return state.historial
        },
        getMensajes(state){
            return state.mensajes
        },
        getInteraccionesEstados: (state) => (estados) =>{
            return state.interacciones.filter(age => estados.includes(age.nombre_estado))
        },
        getUmbralesSlug: (state) => (nombreSlug) => {
            return state.umbrales.find(age => nombreSlug.includes(age.slug))
        },
        getUmbrales(state){
            return state.umbrales
        }
    },

    actions: {
        getDetalleHistorial({commit},data){
            return new Promise((resolve, reject) => {
                axios.get(`getDetalleHistorial?id_inter_global=${data.id_inter_global}`).then(response => {
                    commit('setMensajes',response.data.message)
                    resolve()
                }).catch(error => {
                    commit('setMensajes',[])
                    resolve()
                })
            })
        },
        buscarInteracciones({commit},data){
            console.log(data)
            return new Promise((resolve, reject) => {
                axios.get(`historial?id_inter_global=${data.id_inter_global}&opcion=${data.opcion}`).then(response => {
                    commit('setHistorial',response.data.message)
                    resolve()
                }).catch(error => {
                    commit('setHistorial',[])
                    resolve()
                })
            })
        },
        obtenerInteracciones({commit},data){

            return new Promise((resolve, reject) => {
                axios.post('obtenerInteracciones').then(response => {
                    commit('setInteracciones',response.data.interacciones)
                    resolve()
                }).catch(error => {
                    commit('setInteracciones',[])
                    resolve()
                })
            })
        },
        obtenerUmbrales({commit},data){
            return new Promise((resolve, reject) => {
                axios.post('obtenerUmbrales').then(response => {
                    commit('setUmbrales',response.data.umbrales)
                    resolve()
                }).catch(error => {
                    commit('setInteracciones',[])
                    resolve()
                })
            })
        },
        transferir({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(`transferirInteraccionWeb`, {
                    id_agente: payload.id_agente,
                    id_inter_global: payload.id_inter_global
                }).then(response => {
                    if (response.data.resultado) {
                        resolve(response.data)
                    } else {
                        const error = {
                            message: response.data.message,
                            response: {
                                status: 200
                            }
                        }
                            reject()
                    }
                }).catch(error => {
                    reject()
                })
            })
        }
    },

    mutations: {
        setInteracciones(state,interacciones){
            state.interacciones = interacciones
        },
        setUmbrales(state,umbrales){
            state.umbrales = umbrales
        },
        setHistorial(state,interacciones){
            state.historial = interacciones
        },
        setMensajes(state,mensajes){
            state.mensajes = mensajes

        },
        updateInteracciones(state,interaccion){
            if((interaccion.nombre_estado === 'Contestada') || (interaccion.nombre_estado === 'Pendiente') || (interaccion.nombre_estado === 'Transferida')){
                const existe = state.interacciones.findIndex(inter => inter.id_inter_global === interaccion.id_inter_global)
                if(existe === -1){
                    state.interacciones.push(interaccion)
                }else{
                    if((interaccion.nombre_estado === 'Contestada') || (interaccion.nombre_estado === 'Transferida') || (interaccion.nombre_estado === 'Pendiente')){
                        state.interacciones[existe].nombre_agente = interaccion.nombre_agente
                        state.interacciones[existe].nombre_estado = interaccion.nombre_estado
                    }
                }
            }
            if((interaccion.nombre_estado === 'Finalizada') || (interaccion.nombre_estado === 'Abandonada')){
                const existe = state.interacciones.findIndex(inter => inter.id_inter_global === interaccion.id_inter_global)
                if(existe !== -1){
                    state.interacciones.splice(existe,1)
                }
            }
        },
        cambioEstadoInter(state,payload){
            console.log('cambioEstadoInter')
            console.log(payload)
        }
    }
}